import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import {
  Table,
  Popconfirm,
  Typography,
  notification,
  Space,
  Layout,
} from 'antd';

import BreadcrumbContainer from '../../../containers/Breadcrumb';
import CustomButton from '../../../components/CustomButton';
import SpinLoad from '../../../components/SpinLoad';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';
import { getAll, remove } from '../../../api/module/identification_types';

import './style.scss';
import { PlusOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;
const { Content } = Layout;
const breadcrumbItems = [
  {
    text: 'Tipos de Identificación',
  },
];

export default function IdentitiesTypesList() {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const getDataSource = () => {
    try {
      setLoading(true);
      getAll().then((res) => {
        setDataSource(res.data.results);
        setLoading(false);
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getDataSource();
  }, []);

  // Delete Object by Id of List
  const deleteDataSource = useCallback(
    async (id) => {
      try {
        setLoadingDelete(true);
        const response = await remove(id);
        setLoadingDelete(false);
        if ([200, 201, 204].indexOf(response.status) > -1) {
          notification.success({
            message: MESSAGES.SUCCESS_MSG,
            description: MESSAGES.DESC_SUCCESS_DELETE_MSG,
            duration: 2,
          });
        }
        setDataSource(dataSource.filter((item) => item.id !== id));
      } catch (err) {
        console.log(err);
        notification.error({
          message: MESSAGES.ERROR_MSG,
          description: MESSAGES.DESC_ERROR_DELETE_MSG,
          duration: 2,
        });
      }
    },
    [dataSource],
  );

  const IdentitiesTypeColumns = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Sigla',
      dataIndex: 'sigla',
      key: 'sigla',
    },
    {
      title: 'Acciones',
      dataIndex: 'Acciones',
      align: 'center',
      width: 200,
      render: (_, record) => (
        <Space>
          <CustomButton
            type={'default'}
            className={'ant-btn-info'}
            htmlType="button"
            text={
              <Link to={`${INTERNAL_LINKS.IDENTITY_TYPE}/${record.id}`}>
                Editar
              </Link>
            }
          />
          <CustomButton
            danger
            type={'default'}
            htmlType="button"
            loading={loadingDelete}
            text={
              <Popconfirm
                title={MESSAGES.DELETE_CONFIRM_MSG}
                onConfirm={() => deleteDataSource(record.id)}
              >
                Eliminar
              </Popconfirm>
            }
          />
        </Space>
      ),
    },
  ];

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Módulo de Tipo de documento de identificación
      </Title>
      <Paragraph>
        A continuación, podrá realizar acciones como editar y/o eliminar
        registros contenidos en la siguiente tabla. Si desea agregar un nuevo
        tipo de documento de identificación, por favor, haga click en el botón
        "Crear nuevo tipo de identificación".
      </Paragraph>
      <CustomButton
        type={'default'}
        className={'ant-btn-info'}
        htmlType="button"
        text={
          <Link to={INTERNAL_LINKS.IDENTITY_TYPE}>
            <PlusOutlined /> Crear nuevo tipo de identificación
          </Link>
        }
      />
      <SpinLoad loading={loading}>
        <Table
          rowKey="id"
          scroll={{ x: 400 }}
          dataSource={dataSource}
          columns={IdentitiesTypeColumns}
          title={() => (
            <Paragraph className={'margin-5'} strong>
              Listado de Tipos de identificación
            </Paragraph>
          )}
        />
      </SpinLoad>
    </Content>
  );
}
